import styled from '@emotion/styled'
import { spacing } from 'main/ui'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
`

export const FormRow = styled.fieldset`
  margin-bottom: ${spacing.majorScale(2)}px;
  padding: 0;
  border: none;
`

export const TextContainer = styled.div`
  margin-bottom: ${spacing.majorScale(2)}px;
`

export const TextRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${spacing.majorScale(2)}px;
`
